// store/adminConfig.actions.js
import * as types from './actionTypes';

// ================================INITIAL DATA FETCH ================================ //

export const fetchConfigDataStart = () => ({
  type: types.FETCH_CONFIG_DATA_START
});

export const fetchConfigDataSuccess = (data) => ({
  type: types.FETCH_CONFIG_DATA_SUCCESS,
  payload: data
});

export const fetchConfigDataFailure = (error) => ({
  type: types.FETCH_CONFIG_DATA_FAILURE,
  payload: error
});

// ================================COLLEGE COURSE MAPPING - ASYNC ================================ //

export const createCollegeCourseMappingStart = (data) => ({
  type: types.CREATE_COLLEGE_COURSE_MAPPING_START,
  payload: data
});

export const createCollegeCourseMappingSuccess = (data) => ({
  type: types.CREATE_COLLEGE_COURSE_MAPPING_SUCCESS,
  payload: data
});

export const createCollegeCourseMappingFailure = (error) => ({
  type: types.CREATE_COLLEGE_COURSE_MAPPING_FAILURE,
  payload: error
});

export const updateCollegeCourseMappingStart = (mappingId, data) => ({
  type: types.UPDATE_COLLEGE_COURSE_MAPPING_START,
  payload: { mappingId, data }
});

export const updateCollegeCourseMappingSuccess = (data) => ({
  type: types.UPDATE_COLLEGE_COURSE_MAPPING_SUCCESS,
  payload: data
});

export const updateCollegeCourseMappingFailure = (error) => ({
  type: types.UPDATE_COLLEGE_COURSE_MAPPING_FAILURE,
  payload: error
});

export const deleteCollegeCourseMappingStart = (mappingId) => ({
  type: types.DELETE_COLLEGE_COURSE_MAPPING_START,
  payload: mappingId
});

export const deleteCollegeCourseMappingSuccess = (mappingId) => ({
  type: types.DELETE_COLLEGE_COURSE_MAPPING_SUCCESS,
  payload: mappingId
});

export const deleteCollegeCourseMappingFailure = (error) => ({
  type: types.DELETE_COLLEGE_COURSE_MAPPING_FAILURE,
  payload: error
});

export const fetchCollegeCourseMappingsWithFilters = (filters) => ({
  type: types.FETCH_COLLEGE_COURSE_MAPPINGS_WITH_FILTERS,
  payload: filters
});

// ================================SME COURSE MAPPING - ASYNC ================================ //

export const createSMECourseMappingStart = (data) => ({
  type: types.CREATE_SME_COURSE_MAPPING_START,
  payload: data
});

export const createSMECourseMappingSuccess = (data) => ({
  type: types.CREATE_SME_COURSE_MAPPING_SUCCESS,
  payload: data
});

export const createSMECourseMappingFailure = (error) => ({
  type: types.CREATE_SME_COURSE_MAPPING_FAILURE,
  payload: error
});

export const deleteSMECourseMappingStart = (mappingId) => ({
  type: types.DELETE_SME_COURSE_MAPPING_START,
  payload: mappingId
});

export const deleteSMECourseMappingSuccess = (mappingId) => ({
  type: types.DELETE_SME_COURSE_MAPPING_SUCCESS,
  payload: mappingId
});

export const deleteSMECourseMappingFailure = (error) => ({
  type: types.DELETE_SME_COURSE_MAPPING_FAILURE,
  payload: error
});

export const fetchSMECourseMappingsWithFilters = (filters) => ({
  type: types.FETCH_SME_COURSE_MAPPINGS_WITH_FILTERS,
  payload: filters
});

// ================================DEGREE CONFIGURATION - ASYNC ================================ //

export const createDegreeConfigurationStart = (data) => ({
  type: types.CREATE_DEGREE_CONFIGURATION_START,
  payload: data
});

export const createDegreeConfigurationSuccess = (data) => ({
  type: types.CREATE_DEGREE_CONFIGURATION_SUCCESS,
  payload: data
});

export const createDegreeConfigurationFailure = (error) => ({
  type: types.CREATE_DEGREE_CONFIGURATION_FAILURE,
  payload: error
});

export const updateDegreeConfigurationStart = (degreeId, data) => ({
  type: types.UPDATE_DEGREE_CONFIGURATION_START,
  payload: { degreeId, data }
});

export const updateDegreeConfigurationSuccess = (data) => ({
  type: types.UPDATE_DEGREE_CONFIGURATION_SUCCESS,
  payload: data
});

export const updateDegreeConfigurationFailure = (error) => ({
  type: types.UPDATE_DEGREE_CONFIGURATION_FAILURE,
  payload: error
});

export const deleteDegreeConfigurationStart = (degreeId) => ({
  type: types.DELETE_DEGREE_CONFIGURATION_START,
  payload: degreeId
});

export const deleteDegreeConfigurationSuccess = (degreeId) => ({
  type: types.DELETE_DEGREE_CONFIGURATION_SUCCESS,
  payload: degreeId
});

export const deleteDegreeConfigurationFailure = (error) => ({
  type: types.DELETE_DEGREE_CONFIGURATION_FAILURE,
  payload: error
});

export const fetchDegreeConfigurationsWithFilters = (filters) => ({
  type: types.FETCH_DEGREE_CONFIGURATIONS_WITH_FILTERS,
  payload: filters
});

// ================================LEGACY SYNC ACTIONS ================================ //

export const addCollegeCourseMapping = (mapping) => ({
  type: types.ADD_COLLEGE_COURSE_MAPPING,
  payload: mapping
});

export const updateCollegeCourseMapping = (mapping) => ({
  type: types.UPDATE_COLLEGE_COURSE_MAPPING,
  payload: mapping
});

export const deleteCollegeCourseMapping = (mappingId) => ({
  type: types.DELETE_COLLEGE_COURSE_MAPPING,
  payload: mappingId
});

export const addSMECourseMapping = (mapping) => ({
  type: types.ADD_SME_COURSE_MAPPING,
  payload: mapping
});

export const updateSMECourseMapping = (mapping) => ({
  type: types.UPDATE_SME_COURSE_MAPPING,
  payload: mapping
});

export const deleteSMECourseMapping = (mappingId) => ({
  type: types.DELETE_SME_COURSE_MAPPING,
  payload: mappingId
});

export const addDegreeCourseMapping = (mapping) => ({
  type: types.ADD_DEGREE_COURSE_MAPPING,
  payload: mapping
});

export const updateDegreeCourseMapping = (mapping) => ({
  type: types.UPDATE_DEGREE_COURSE_MAPPING,
  payload: mapping
});

export const deleteDegreeCourseMapping = (mappingId) => ({
  type: types.DELETE_DEGREE_COURSE_MAPPING,
  payload: mappingId
});

export const addLanguageCourseMapping = (mapping) => ({
  type: types.ADD_LANGUAGE_COURSE_MAPPING,
  payload: mapping
});

export const updateLanguageCourseMapping = (mapping) => ({
  type: types.UPDATE_LANGUAGE_COURSE_MAPPING,
  payload: mapping
});

export const deleteLanguageCourseMapping = (mappingId) => ({
  type: types.DELETE_LANGUAGE_COURSE_MAPPING,
  payload: mappingId
});

// store/admin/admin-config/actions.js

// College Degree Mapping Actions
export const fetchCollegeDegreeMappingsStart = (params = {}) => ({
  type: types.FETCH_COLLEGE_DEGREE_MAPPINGS_START,
  payload: params
});

export const fetchCollegeDegreeMappingsSuccess = (data) => ({
  type: types.FETCH_COLLEGE_DEGREE_MAPPINGS_SUCCESS,
  payload: data
});

export const fetchCollegeDegreeMappingsFailure = (error) => ({
  type: types.FETCH_COLLEGE_DEGREE_MAPPINGS_FAILURE,
  payload: error
});

export const createCollegeDegreeMappingStart = (mappingData) => ({
  type: types.CREATE_COLLEGE_DEGREE_MAPPING_START,
  payload: mappingData
});

export const createCollegeDegreeMappingSuccess = (mapping) => ({
  type: types.CREATE_COLLEGE_DEGREE_MAPPING_SUCCESS,
  payload: mapping
});

export const createCollegeDegreeMappingFailure = (error) => ({
  type: types.CREATE_COLLEGE_DEGREE_MAPPING_FAILURE,
  payload: error
});

export const updateCollegeDegreeMappingStart = (mappingId, updateData) => ({
  type: types.UPDATE_COLLEGE_DEGREE_MAPPING_START,
  payload: { mappingId, updateData }
});

export const updateCollegeDegreeMappingSuccess = (mapping) => ({
  type: types.UPDATE_COLLEGE_DEGREE_MAPPING_SUCCESS,
  payload: mapping
});

export const updateCollegeDegreeMappingFailure = (error) => ({
  type: types.UPDATE_COLLEGE_DEGREE_MAPPING_FAILURE,
  payload: error
});

export const deleteCollegeDegreeMappingStart = (mappingId) => ({
  type: types.DELETE_COLLEGE_DEGREE_MAPPING_START,
  payload: mappingId
});

export const deleteCollegeDegreeMappingSuccess = (mappingId) => ({
  type: types.DELETE_COLLEGE_DEGREE_MAPPING_SUCCESS,
  payload: mappingId
});

export const deleteCollegeDegreeMappingFailure = (error) => ({
  type: types.DELETE_COLLEGE_DEGREE_MAPPING_FAILURE,
  payload: error
});
 export const fetchCollegeDegreesStart = (collegeId) => ({
  type: types.FETCH_COLLEGE_DEGREES_START,
  payload: { collegeId }
});

export const fetchCollegeDegreesSuccess = (degrees) => ({
  type: types.FETCH_COLLEGE_DEGREES_SUCCESS,
  payload: degrees
});

export const fetchCollegeDegreesFailure = (error) => ({
  type: types.FETCH_COLLEGE_DEGREES_FAILURE,
  payload: error
});

export const clearCollegeDegrees = () => ({
  type: types.CLEAR_COLLEGE_DEGREES
});

// ================================UI STATE ================================ //

export const setLoading = (loading) => ({
  type: types.SET_LOADING,
  payload: loading
});

export const clearError = () => ({
  type: types.CLEAR_ERROR
});

// ================================SEMESTER PROMOTION ================================ //

export const promoteSemesterStart = (data) => ({
  type: types.PROMOTE_SEMESTER_START,
  payload: data
});

export const promoteSemesterSuccess = (data) => ({
  type: types.PROMOTE_SEMESTER_SUCCESS,
  payload: data
});

export const promoteSemesterFailure = (error) => ({
  type: types.PROMOTE_SEMESTER_FAILURE,
  payload: error
});

export const clearPromotionResult = () => ({
  type: types.CLEAR_PROMOTION_RESULT
});

export const previewSemesterStart = (data) => ({
  type: types.PREVIEW_SEMESTER_START,
  payload: data
});

export const previewSemesterSuccess = (data) => ({
  type: types.PREVIEW_SEMESTER_SUCCESS,
  payload: data
});

export const previewSemesterFailure = (error) => ({
  type: types.PREVIEW_SEMESTER_FAILURE,
  payload: error
});

export const clearSemesterPreview = () => ({
  type: types.CLEAR_SEMESTER_PREVIEW
});